// removed by extract-text-webpack-plugin
module.exports = {"loader":"Spinner__loader___3qv_p","load4":"Spinner__load4___10vDm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 158
// module chunks = 0